const versions = {
    ui: '97bbaae79cf6751d83a5ae44150ecfa913c8e727'
};

export default versions;
